import { isActiveValue } from '../../../components/CatalogFilterModel/filterModel';
import type { CatalogFiltersType } from './useCatalogTable';

export const hasActiveFilters = (
  filters?: CatalogFiltersType,
): boolean => {
  if (!filters) return false;
  return Object.values(filters).some(isActiveValue);
};
